// extracted by mini-css-extract-plugin
export default {"container":"pp-z","brandName":"qp-z","productName":"rp-z","productNamePdpEnhancements":"sp-z","breakLongProductName":"tp-z"};